import React from 'react';
import CompanyApplications from '../../components/scadOffice/CompanyApplications/CompanyApplications';

const Companies = () => {
  return (
    <div>
      <CompanyApplications />
    </div>
  );
};

export default Companies;